import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfile } from '../models/role.model';

export type ProfilePatch = {
  firstName?: string;
  lastName?: string;
  displayName?: string;
  username?: string;
  timezone?: string;
};


export interface ProfileApi {
  loadProfile(uid: string): Observable<UserProfile>;
  updateProfile(uid: string, patch: ProfilePatch): Observable<void>;
}

export const PROFILE_API = new InjectionToken<ProfileApi>('PROFILE_API');
